/*
 * General utils for managing cookies
 */

import { generateUniqueId } from './utils';

export const HB_SESSION = 'hb-session';
export const SESSION_DEFAULT_DURATION = 60 * 60 * 1000; // 1 hour
export const CIVITFUN_METRICS_CHECKIN_SESSION = 'cf-metrics-checkin-session';
export const CIVITFUN_METRICS_CHECKIN_SESSION_DURATION = 10 * 60 * 1000; // 10 min
export const CIVITFUN_METRICS_CHECKIN_SESSION_DURATION_PAPERLESS = 10 * 60 * 1000; // 10 min

function setCookie(name, value, expiryTime = SESSION_DEFAULT_DURATION) {
  const date = new Date();
  date.setTime(date.getTime() + expiryTime);

  // Set it
  document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
}

function getCookie(name) {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}

function deleteCookie(name) {
  const date = new Date();
  // Set it expire in -1 days
  date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);
  document.cookie = name + '=; expires=' + date.toUTCString() + '; path=/';
}

function createMetricsCookie(expiryTime = CIVITFUN_METRICS_CHECKIN_SESSION_DURATION) {
  const cookie = getCookie(CIVITFUN_METRICS_CHECKIN_SESSION);
  if (!cookie) {
    setCookie(CIVITFUN_METRICS_CHECKIN_SESSION, generateUniqueId(), expiryTime);
  }
}

function resetCookie(name, value, expiryTime) {
  deleteCookie(name);
  setCookie(name, value);
}

function resetMetricsCookie(expiryTime = CIVITFUN_METRICS_CHECKIN_SESSION_DURATION_PAPERLESS) {
  resetCookie(CIVITFUN_METRICS_CHECKIN_SESSION, generateUniqueId(), expiryTime);
}

export { setCookie, getCookie, deleteCookie, createMetricsCookie, resetCookie, resetMetricsCookie };
